<div class="tw-font-body">
  <img class="tw-m-auto tw-rounded-full" src="/assets/images/sand-watch-loader.gif" width="80px" height="80px" />  
  <ng-content select="[slot=sub-header]"></ng-content>
  <ng-content select="[slot=header]"></ng-content>
  <div class="tw-w-full tw-bg-teal-600 tw-text-white tw-rounded-3 tw-py-3 tw-text-center tw-font-bold tw-text-500 tw-capitalize" (click)="onSubmit()">
    <ng-content select="[slot=button-text]"></ng-content>
  </div>
</div>
